var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSafeEnvironment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.097,
    height: 32.5,
    viewBox: "0 0 26.097 32.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1278",
    "data-name": "Grupo 1278",
    transform: "translate(-317.676 36.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_750",
    "data-name": "Ret\\xE2ngulo 750",
    d: "M2.462-1.5H20.635A3.967,3.967,0,0,1,24.6,2.462V15.049a3.967,3.967,0,0,1-3.962,3.962H2.462A3.967,3.967,0,0,1-1.5,15.049V2.462A3.967,3.967,0,0,1,2.462-1.5ZM20.635,17.837a2.791,2.791,0,0,0,2.787-2.787V2.462A2.791,2.791,0,0,0,20.635-.325H2.462A2.791,2.791,0,0,0-.325,2.462V15.049a2.791,2.791,0,0,0,2.787,2.787Z",
    transform: "translate(319.176 -23.011)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1278-2",
    "data-name": "Grupo 1278",
    transform: "translate(322.359 -36.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_844",
    "data-name": "Caminho 844",
    d: "M346.493,175.471a.587.587,0,0,1-.587-.587v-4.211a4.1,4.1,0,1,0-8.193,0v4.211a.587.587,0,0,1-1.175,0v-4.211a5.271,5.271,0,1,1,10.542,0v4.211A.587.587,0,0,1,346.493,175.471Z",
    transform: "translate(-333.444 -162.307)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_845",
    "data-name": "Caminho 845",
    d: "M344.779,170.663a.587.587,0,0,1-.587-.587v-4.211a7.19,7.19,0,1,0-14.38,0v4.211a.587.587,0,1,1-1.175,0v-4.211a8.365,8.365,0,1,1,16.73,0v4.211A.587.587,0,0,1,344.779,170.663Z",
    transform: "translate(-328.637 -157.5)",
    fill: "current"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Elipse_293",
    "data-name": "Elipse 293",
    d: "M7.3,0a7.306,7.306,0,0,1,2.843,14.034A7.306,7.306,0,0,1,4.461.574,7.259,7.259,0,0,1,7.3,0Zm0,13.434A6.13,6.13,0,1,0,1.175,7.3,6.137,6.137,0,0,0,7.3,13.434Z",
    transform: "matrix(0.9, -0.436, 0.436, 0.9, 320.965, -17.641)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_903",
    "data-name": "Caminho 903",
    d: "M343.468,212.906a.586.586,0,0,1-.415-.172l-2.621-2.621a.587.587,0,0,1,.831-.831l2.206,2.206,3.87-3.87a.587.587,0,0,1,.831.831l-4.285,4.285A.585.585,0,0,1,343.468,212.906Z",
    transform: "translate(-13.349 -224.389)",
    fill: "current"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafeEnvironment);
export default __webpack_public_path__ + "static/media/safeEnvironment.117a3376cf8892bf8ced831356ccf2c2.svg";
export { ForwardRef as ReactComponent };